import React from 'react';

import {
  Dashboard,
  Assessment,
  Summarize,
  Inventory,
  Redeem,
  AccountTree,
  Receipt,
  PersonPin,
  Settings,
  Diversity3,
  Contacts,
} from '@mui/icons-material';

const menuTabItems = [
  {
    icon: <Dashboard />,
    title: 'Dashboard',
    slug: 'dashboard_parent_menu',
    permissions: [
      'KASM',
      'KASROM',
      'KASOM',
      'KASH',
      'SAM',
      'RSM',
      'NSM-SPARTAN',
      'HTAM',
      'NSM-HOSPITAL',
      'admin',
      'SD',
      'PM',
      'GPM',
      'DAM',
      'CNC-MANAGER',
      'CNC-ADMIN',
      'CNC-ANALYST',
      'COO',
      'EXECUTIVE',
    ],
    child: [
      {
        icon: <Dashboard />,
        title: 'CRM Dashboard',
        slug: 'crm_dashboard',
        url: '/dashboard/crm',
        permissions: [
          'KASM',
          'KASROM',
          'KASOM',
          'KASH',
          'SAM',
          'RSM',
          'NSM-SPARTAN',
          'admin',
          'PM',
          'GPM',
          'COO',
          'EXECUTIVE',
        ],
      },
      {
        icon: <Dashboard />,
        title: 'Field Engagement',
        slug: 'field_engagement',
        url: '/report/field-engagement',
        permissions: ['DAM', 'CNC-ADMIN', 'CNC-MANAGER', 'CNC-ANALYST'],
      },
      {
        icon: <Dashboard />,
        title: 'Hospital Coverage',
        slug: 'hospital_coverage',
        url: '/dashboard/hospital-coverage',
        permissions: ['HTAM', 'NSM-HOSPITAL', 'SD', 'EXECUTIVE'],
      },
      {
        icon: <Dashboard />,
        title: 'HCP Coverage',
        slug: 'hcp_coverage',
        url: '/dashboard/hcp',
        permissions: ['HTAM', 'NSM-HOSPITAL', 'SD', 'EXECUTIVE'],
      },
      {
        icon: <Dashboard />,
        title: 'PRD Dashboard Report',
        slug: 'prd_dashboard_report',
        url: '/dashboard/prd',
        permissions: [
          'KASM',
          'KASOM',
          'KASROM',
          'KASH',
          'SAM',
          'RSM',
          'NSM-SPARTAN',
          'admin',
          'COO',
          'EXECUTIVE',
        ],
      },
      {
        icon: <Dashboard />,
        title: 'MD Report',
        slug: 'md_report',
        url: '/manager-dashboard',
        permissions: [
          'KASM',
          'KASOM',
          'KASROM',
          'KASH',
          'SAM',
          'RSM',
          'NSM-SPARTAN',
          'admin',
          'COO',
          'EXECUTIVE',
        ],
      },
      {
        icon: <Dashboard />,
        title: '90-90-90 Report',
        slug: 'ninety_ninety_ninety_report',
        url: '/report/ninety-ninety-report',
        permissions: [
          'KASM',
          'KASOM',
          'KASROM',
          'KASH',
          'SAM',
          'RSM',
          'NSM-SPARTAN',
          'admin',
          'COO',
          'EXECUTIVE',
        ],
      },
      {
        icon: <Dashboard />,
        title: 'External Team Dashboard',
        slug: 'external_team_dashborad',
        url: '/dashboard/team',
        permissions: ['admin', 'COO', 'EXECUTIVE'],
      },
      {
        icon: <Dashboard />,
        title: 'Sales - Weekly Report',
        slug: 'sales_weekly_report',
        url: '/report/sales-weekly',
        permissions: ['KASH', 'NSM-SPARTAN', 'admin', 'PM', 'GPM', 'COO', 'EXECUTIVE'],
      },
      {
        icon: <Dashboard />,
        title: 'Report Access Generator',
        slug: 'report_access_generator',
        url: '/report/access-generator',
        permissions: ['admin', 'COO', 'EXECUTIVE'],
      },
    ],
  },
  {
    icon: <Assessment />,
    title: 'Cycle Work Plan',
    slug: 'cycle_work_plan_parent_menu',
    permissions: [
      'KASM',
      'KASROM',
      'KASOM',
      'KASH',
      'SAM',
      'RSM',
      'HTAM',
      'NSM-SPARTAN',
      'NSM-HOSPITAL',
      'admin',
      'DAM',
      'SD',
      'COO',
      'EXECUTIVE',
      'SFE',
    ],
    child: [
      {
        icon: <Assessment />,
        title: 'CWP Approval',
        url: '/approvals/cwp',
        slug: 'cwp_approvals',
        permissions: ['KASM', 'SAM'],
      },
      {
        icon: <Assessment />,
        title: 'CWP Approval',
        url: '/approval/cwp-approval-cnc',
        slug: 'cwp_approvals',
        permissions: ['DAM'],
      },
      {
        icon: <Assessment />,
        title: 'CWP Approval',
        url: '/cwp-approval',
        slug: 'cwp_approvals',
        permissions: ['HTAM'],
      },
      {
        icon: <Assessment />,
        title: 'CWP Deletion Request',
        slug: 'cwp-maintenance',
        url: '/cwp-maintenance',
        permissions: ['admin', 'KASM', 'SAM'],
      },
      {
        icon: <Assessment />,
        title: 'Target Update Approval',
        slug: 'target_maintenance',
        url: '/target-maintenance',
        permissions: ['admin', 'KASM', 'KASROM', 'KASOM', 'SAM', 'RSM'],
      },
      {
        icon: <Assessment />,
        title: 'HTAR Target Update Approval',
        slug: 'htar-target_maintenance',
        url: '/htar-target-maintenance',
        permissions: ['HTAM', 'NSM-HOSPITAL'],
      },
      {
        icon: <Assessment />,
        title: 'CWP Cancellation/Deletion',
        url: '/cwp-maintenance-deletion-request',
        slug: 'cwp-maintenance-deletion-request',
        permissions: ['admin'],
      },
      {
        icon: <Assessment />,
        title: 'Cycle Work Plan Extractor',
        slug: 'cwp_plot',
        url: 'report/cwp_plot',
        permissions: [
          'KASM',
          'KASOM',
          'KASROM',
          'KASH',
          'SAM',
          'RSM',
          'HTAM',
          'NSM-SPARTAN',
          'NSM-HOSPITAL',
          'admin',
          'SD',
          'COO',
          'EXECUTIVE',
          'SFE',
        ],
        type: 'modal',
      },
    ],
  },
  {
    icon: <Summarize />,
    title: 'Daily Call Report',
    slug: 'daily_call_report_parent_menu',
    permissions: [
      'KASM',
      'KASOM',
      'KASROM',
      'KASH',
      'SAM',
      'RSM',
      'HTAM',
      'NSM-SPARTAN',
      'NSM-HOSPITAL',
      'admin',
      'SD',
      'COO',
      'EXECUTIVE',
      'SFE',
    ],
    child: [
      {
        icon: <Summarize />,
        title: 'DCR Viewer',
        url: '/dcr-listing',
        slug: 'dcr_listing',
        permissions: [
          'KASM',
          'KASOM',
          'KASROM',
          'KASH',
          'SAM',
          'RSM',
          'NSM-SPARTAN',
          'admin',
          'COO',
          'EXECUTIVE',
          'SFE',
        ],
      },
      {
        icon: <Summarize />,
        title: 'Daily Call Report Extractor',
        slug: 'dcr',
        url: 'report/dcr',
        type: 'modal',
        permissions: [
          'KASM',
          'KASOM',
          'KASROM',
          'KASH',
          'SAM',
          'NSM-SPARTAN',
          'HTAM',
          'NSM-HOSPITAL',
          'admin',
          'SD',
          'COO',
          'EXECUTIVE',
          'SFE',
        ],
      },
    ],
  },
  {
    icon: <Inventory />,
    title: 'Product Related',
    slug: 'product_related_parent_menu',
    permissions: ['admin', 'PM', 'GPM', 'COO', 'EXECUTIVE'],
    child: [
      {
        icon: <Inventory />,
        title: 'Product Inventory Balance v2',
        url: '/maintenance/product-inventory-balance-v2',
        slug: 'product-inventory-balance-maintenance',
        permissions: ['PM', 'GPM'],
      },
      {
        icon: <Inventory />,
        title: 'Product Allocation',
        url: '/maintenance/product-allocation',
        slug: 'product-allocation-maintenance',
        permissions: ['PM', 'GPM'],
      },
      {
        icon: <Inventory />,
        title: 'Product Sampling Inventory',
        slug: 'product_sampling_inventory_report',
        url: '/report/product_sampling_inventory_report',
        permissions: ['PM', 'GPM'],
      },
      {
        icon: <Inventory />,
        title: 'Product Sampling',
        url: '/maintenance/product-sampling',
        slug: 'maintenance-product-sampling',
        permissions: ['admin', 'PM', 'GPM', 'COO', 'EXECUTIVE'],
      },
      {
        icon: <Inventory />,
        title: 'Product Sampling Overview',
        url: '/maintenance/product-sampling-overview',
        slug: 'maintenance-product-sampling-overview',
        permissions: ['admin', 'PM'],
      },
      {
        icon: <Inventory />,
        title: 'Product Sampling Status',
        url: '/maintenance/product-sampling-details/status',
        slug: 'maintenance-product-sampling-status',
        permissions: ['admin', 'PM'],
      },
      {
        icon: <Inventory />,
        title: 'Weekly Product Report Extractor',
        slug: 'weekly_product_report',
        url: 'report/weekly_product_report',
        type: 'modal',
        permissions: ['admin', 'PM', 'GPM', 'COO', 'EXECUTIVE'],
      },
      {
        icon: <Inventory />,
        title: 'Product Utilization Extractor',
        slug: 'product_util',
        url: 'report/product_util',
        type: 'modal',
        permissions: ['admin', 'PM', 'GPM', 'COO', 'EXECUTIVE'],
      },
      {
        icon: <Inventory />,
        title: '6ps Product Utilization Extractor',
        slug: '6psProductUtilization',
        url: 'report/6psProductUtilization',
        type: 'modal',
        permissions: ['admin'],
      },
    ],
  },
  {
    icon: <Redeem />,
    title: 'Purchase Order',
    slug: 'purchase_order_parent_menu',
    permissions: ['HTAM', 'NSM-HOSPITAL', 'admin', 'SD', 'EXECUTIVE'],
    child: [
      {
        icon: <Redeem />,
        title: 'Purchase Order Extractor',
        slug: 'purchase_order',
        url: 'report/puchase_order',
        type: 'modal',
        permissions: ['HTAM', 'NSM-HOSPITAL', 'admin', 'SD', 'EXECUTIVE'],
      },
    ],
  },
  {
    icon: <AccountTree />,
    title: 'Footprint Tracker',
    slug: 'footprint_tracker_parent_menu',
    permissions: ['admin'],
    child: [
      {
        icon: <AccountTree />,
        title: 'What Went Well Maintenace',
        url: '/maintenance/what-went-well',
        slug: 'agenda-maintenance',
        permissions: ['admin'],
      },
      {
        icon: <AccountTree />,
        title: 'Area for Imporvements',
        url: '/maintenence/area-for-imporvements',
        slug: 'area-for-improvements',
        permissions: ['admin'],
      },
    ],
  },
  {
    icon: <Receipt />,
    title: 'Marketing',
    slug: 'receipt_parent_menu',
    permissions: [
      'KASM',
      'KASROM',
      'KASOM',
      'KASH',
      'SAM',
      'RSM',
      'NSM-SPARTAN',
      'PM',
      'GPM',
      'admin',
      'COO',
      'EXECUTIVE',
    ],
    child: [
      {
        icon: <Receipt />,
        title: 'Marketing Materials',
        slug: 'marketing_materials',
        url: '/marketing-materials',
        permissions: [
          'KASM',
          'KASROM',
          'KASOM',
          'KASH',
          'SAM',
          'RSM',
          'NSM-SPARTAN',
          'admin',
          'PM',
          'GPM',
          'COO',
          'EXECUTIVE',
        ],
      },
      {
        icon: <Receipt />,
        title: 'Presentation Log',
        slug: 'presentation_log',
        url: 'report/presentation_log',
        type: 'modal',
        permissions: ['admin', 'COO', 'EXECUTIVE'],
      },
      {
        icon: <Receipt />,
        title: 'Product Presentation Extractor',
        slug: 'product_presentaion',
        url: 'report/product_presentaion',
        type: 'modal',
        permissions: ['admin', 'KASM', 'SAM'],
      },
      {
        icon: <Receipt />,
        title: 'Materials Utilization',
        slug: 'material_util',
        url: 'report/material_util',
        type: 'modal',
        permissions: ['admin', 'PM'],
      },
    ],
  },
  {
    icon: <PersonPin />,
    title: 'Users',
    slug: 'users_parent_menu',
    permissions: ['admin', 'COO', 'EXECUTIVE'],
    child: [
      {
        icon: <PersonPin />,
        title: 'Location Tracker Log',
        slug: 'location_tracker_log',
        url: 'report/location_traceker_log',
        type: 'modal',
        permissions: ['admin', 'COO', 'EXECUTIVE'],
      },
    ],
  },
  {
    icon: <Settings />,
    title: 'Maintenance',
    slug: 'maintenance_parent_menu',
    permissions: [
      'KASM',
      'KASROM',
      'KASOM',
      'SAM',
      'RSM',
      'NSM-SPARTAN',
      'HTAM',
      'NSM-HOSPITAL',
      'admin',
      'PM',
      'GPM',
      'DAM',
      'SD',
      'COO',
      'EXECUTIVE',
    ],
    child: [
      {
        icon: <Settings />,
        title: 'Event Calendar',
        url: '/maintenance/event-calendar',
        slug: 'event-calendar-maintenance',
        permissions: [
          'KASM',
          'KASROM',
          'KASOM',
          'SAM',
          'RSM',
          'NSM-SPARTAN',
          'HTAM',
          'NSM-HOSPITAL',
          'admin',
          'SD',
          'PM',
          'GPM',
          'DAM',
          'COO',
          'EXECUTIVE',
        ],
      },
      {
        icon: <Settings />,
        title: 'Feedback Maintenance',
        url: '/feedbacks/maintenance',
        slug: 'feedback-maintenance',
        permissions: ['admin'],
      },
    ],
  },
  {
    icon: <Diversity3 />,
    title: 'Client Call Out',
    slug: 'client_call_out_parent_menu',
    permissions: ['DAM', 'CNC-ADMIN', 'CNC-MANAGER', 'CNC-ANALYST'],
    child: [
      {
        icon: <Diversity3 />,
        title: 'Client Call Out Dashboard',
        slug: 'client_call_out_dashboard',
        url: '/dashboard/client-call-out',
        permissions: ['DAM', 'CNC-ADMIN', 'CNC-MANAGER', 'CNC-ANALYST'],
      },
      {
        icon: <Diversity3 />,
        title: 'My Client Call Outs',
        slug: 'my_client_call_out_dashboard',
        url: '/dashboard/my-client-call-out',
        permissions: ['CNC-ADMIN', 'CNC-MANAGER', 'CNC-ANALYST'],
      },
      {
        icon: <Diversity3 />,
        title: 'Client Call Out Extractor',
        slug: 'client_call_out_extractor',
        url: 'report/client_call_out',
        type: 'modal',
        permissions: ['CNC-ADMIN', 'CNC-MANAGER', 'CNC-ANALYST'],
      },
      {
        icon: <Diversity3 />,
        title: 'Account Tagging Maintenance',
        slug: 'admin_tagged_account_sub_menu',
        url: 'upload/tagged-accounts',
        permissions: ['CNC-ANALYST'],
        type: 'modal',
      },
      {
        icon: <Diversity3 />,
        title: 'Footprint',
        slug: 'footprint_report_child_menu',
        url: '/report/footprint',
        permissions: ['CNC-ADMIN', 'CNC-ANALYST'],
      },
    ],
  },
  {
    icon: <Contacts />,
    title: 'MD Universe',
    slug: 'md_universe_parent_menu',
    permissions: ['admin', 'KASM', 'KASROM', 'KASOM', 'SAM', 'RSM', 'COO', 'EXECUTIVE'],
    child: [
      {
        icon: <Contacts />,
        title: 'MD Profile Dashboard',
        slug: 'md_profile_dashboard',
        url: '/dashboard/md-profile',
        permissions: ['admin', 'KASM', 'KASROM', 'KASOM', 'SAM', 'RSM', 'COO', 'EXECUTIVE'],
      },
      {
        icon: <Contacts />,
        title: 'MD Masterlist',
        slug: 'md_masterlist',
        url: '/md-universe/md-masterlist',
        permissions: ['admin', 'KASM', 'KASROM', 'KASOM', 'SAM', 'RSM'],
      },
      {
        icon: <Diversity3 />,
        title: 'MD Issue & Concern',
        slug: 'md_ticket_extractor',
        url: 'report/md_ticket_extractor',
        permissions: ['admin', 'KASM', 'KASROM', 'KASOM', 'SAM', 'RSM', 'COO', 'EXECUTIVE'],
        type: 'modal',
      },
    ],
  },
];

export default menuTabItems;
